import { render, staticRenderFns } from "./videoCenter.vue?vue&type=template&id=7522f86e&scoped=true&"
import script from "./videoCenter.vue?vue&type=script&lang=js&"
export * from "./videoCenter.vue?vue&type=script&lang=js&"
import style1 from "./videoCenter.vue?vue&type=style&index=1&id=7522f86e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7522f86e",
  null
  
)

export default component.exports